export const GET_FAMILIES = 'GET_FAMILIES';
export const GET_FAMILIE_BY_ID = 'GET_FAMILIE_BY_ID';
export const UPDATE_FAMILIE = 'UPDATE_FAMILIE';
export const DELETE_FAMILIE = 'DELETE_FAMILIE';
export const CREATE_FAMILIE = 'CREATE_FAMILIE';
